import { create } from "zustand";
import { get as apiGet, ApiError } from "@/api/client";
import { GPNSVlanListSchema, type GPNSVlan } from "@/api/schemas/gpns-vlans";

interface State {
  data: GPNSVlan[];
  status: "idle" | "loading" | "ready" | "error";
  error: string | null;
  load: () => Promise<void>;
}

export const useGpnsVlans = create<State>((set, get) => ({
  data: [],
  status: "idle",
  error: null,
  load: async () => {
    if (get().status === "loading") return;
    set({ status: "loading", error: null });
    try {
      const raw = await apiGet<unknown>("/config-generator/gpnsvlans/");
      set({ data: GPNSVlanListSchema.parse(raw), status: "ready" });
    } catch (err) {
      const message =
        err instanceof ApiError
          ? `API error ${err.status}`
          : err instanceof Error
            ? err.message
            : "unknown error";
      set({ data: [], status: "error", error: message });
    }
  },
}));
